<template>
  <div class="main-sidebar main-sidebar-sticky side-menu">
    <div class="sidemenu-logo">
      <router-link class="main-logo" :to="{ name: 'index' }">
        <img
          src="/assets/img/brand/logo-light.png"
          class="header-brand-img desktop-logo"
          alt="کارت هدیه آریا"
        />
        <img
          src="/assets/img/brand/icon-light.png"
          class="header-brand-img icon-logo"
          alt="کارت هدیه آریا"
        />
      </router-link>
    </div>
    <div class="main-sidebar-body">
      <ul class="nav">
        <li class="nav-item" v-if="$store.state.role != 'izbank-finance'">
          <router-link class="nav-link" :to="{ name: 'index' }"
            ><span class="shape1"></span><span class="shape2"></span
            ><i class="ti-home sidemenu-icon"></i
            ><span class="sidemenu-label">داشبورد</span></router-link
          >
        </li>
        <li
          class="nav-item has-children"
          v-if="
            $store.state.role == 'admin' ||
              $store.state.role == 'branches' ||
              $store.state.role == 'izbank-admin' ||
              $store.state.role == 'izbank-finance' ||
              $store.state.role == 'org' ||
              $store.state.role == 'organization'
          "
        >
          <a class="nav-link with-sub" href="/report">
            <span class="shape1"></span><span class="shape2"></span
            ><i class="ti-bar-chart-alt sidemenu-icon"></i
            ><span class="sidemenu-label">گزارشات</span
            ><i class="angle fe fe-chevron-left"></i>
          </a>
          <ul class="nav-sub">
            <li class="nav-sub-item">
              <router-link
                class="nav-sub-link"
                v-if="
                  $store.state.role == 'admin' ||
                    $store.state.role == 'izbank-admin'
                "
                :to="{ name: 'bankBranches.reports.detailGift' }"
                >سفارشات کارت شخصی سازی شده</router-link
              >
            </li>
            <li class="nav-sub-item">
              <router-link
                class="nav-sub-link"
                :to="{ name: 'bankBranches.reports.transactions' }"
                >تراکنش ها</router-link
              >
            </li>
            <li class="nav-sub-item">
              <router-link
                class="nav-sub-link"
                v-if="
                  $store.state.role == 'admin' ||
                    $store.state.role == 'izbank-admin'
                "
                :to="{ name: 'bankBranches.reports.cardBody' }"
                >جسم کارت</router-link
              >
            </li>
            <li class="nav-sub-item">
              <router-link
                class="nav-sub-link"
                v-if="
                  $store.state.role == 'admin' ||
                    $store.state.role == 'izbank-admin'
                "
                :to="{ name: 'bankBranches.reports.bill' }"
                >صورت وضعیت</router-link
              >
            </li>
            <li class="nav-sub-item" v-if="$store.state.role != 'org'">
              <router-link
                class="nav-sub-link"
                :to="{ name: 'bankBranches.events' }"
                >رویداد های کارت</router-link
              >
            </li>
            <li class="nav-sub-item" v-if="$store.state.role != 'org'">
              <router-link
                class="nav-sub-link"
                :to="{ name: 'bankBranches.reports.charge' }"
                >شارژ کارت</router-link
              >
            </li>
            <li
              class="nav-sub-item"
              v-if="
                $store.state.role != 'admin' ||
                  $store.state.role != 'organization' ||
                  $store.state.role != 'branches'
              "
            >
              <router-link
                class="nav-sub-link"
                :to="{ name: 'changePin.reports' }"
                >تغییر رمز مستقیم</router-link
              >
            </li>
            <!-- <li class="nav-sub-item" v-if="$store.state.role != 'org'"><router-link class="nav-sub-link" :to="{name: 'bankBranches.reports.express'}">مرسولات پستی</router-link></li> -->
          </ul>
        </li>
        <li class="nav-item" v-if="$store.state.role == 'admin'">
          <router-link class="nav-link" :to="{ name: 'orders.create' }"
            ><span class="shape1"></span><span class="shape2"></span
            ><i class="ti-package sidemenu-icon"></i
            ><span class="sidemenu-label">سفارش کارت هدیه</span></router-link
          >
        </li>
        <li
          class="nav-item"
          v-if="
            $store.state.role == 'admin' ||
              $store.state.role == 'branches' ||
              $store.state.role == 'organization' ||
              $store.state.role == 'jahesh'
          "
        >
          <router-link class="nav-link" :to="{ name: 'changePin' }"
            ><span class="shape1"></span><span class="shape2"></span
            ><i class="ti-lock sidemenu-icon"></i
            ><span class="sidemenu-label">تغییر رمز مستقیم</span></router-link
          >
        </li>
        <li
          class="nav-item"
          v-if="
            $store.state.role == 'admin' ||
              $store.state.role == 'branches' ||
              $store.state.role == 'izbank-admin'
          "
        >
          <router-link class="nav-link" :to="{ name: 'organizations' }"
            ><span class="shape1"></span><span class="shape2"></span
            ><i class="ti-bookmark-alt sidemenu-icon"></i
            ><span class="sidemenu-label">سازمان ها</span></router-link
          >
        </li>

        <li
          class="nav-item"
          v-if="$store.state.role == 'admin' || $store.state.role == 'finance'"
        >
          <a href="/organizationCharge" class="nav-link with-sub">
            <span class="shape1"></span><span class="shape2"></span
            ><i class="ti-id-badge sidemenu-icon"></i
            ><span class="sidemenu-label">شارژ سازمان</span
            ><i class="angle fe fe-chevron-left"></i>
          </a>
          <ul class="nav-sub">
            <li v-if="$store.state.role == 'admin'" class="nav-sub-item">
              <router-link
                class="nav-sub-link"
                :to="{ name: 'organizationCharge.create' }"
              >
                ایجاد شارژ کارت</router-link
              >
            </li>
            <li
              class="nav-sub-item"
              v-if="
                $store.state.role == 'finance' || $store.state.role == 'admin'
              "
            >
              <router-link
                class="nav-sub-link"
                :to="{ name: 'organizationCharge.list' }"
              >
                لیست درخواست ها</router-link
              >
            </li>
            <!-- <li class="nav-sub-item" v-if="$store.state.role == 'finance'">
                            <router-link
                                class="nav-sub-link"
                                :to="{ name: 'organizationCharge.report' }"
                                >گزارشات</router-link
                            >
                        </li> -->
          </ul>
        </li>

        <li class="nav-item" v-if="$store.state.role == 'admin'">
          <router-link class="nav-link" :to="{ name: 'users' }"
            ><span class="shape1"></span><span class="shape2"></span
            ><i class="ti-user sidemenu-icon"></i
            ><span class="sidemenu-label">کاربران</span></router-link
          >
        </li>
        <li class="nav-item" v-if="$store.state.role == 'admin'">
          <router-link
            class="nav-link"
            :to="{ name: 'admin.organizationOrder' }"
            ><span class="shape1"></span><span class="shape2"></span
            ><i class="ti-world sidemenu-icon"></i
            ><span class="sidemenu-label">ثبت سفارش سازمانی</span></router-link
          >
        </li>
        <li class="nav-item" v-if="$store.state.role == 'organization'">
          <router-link class="nav-link" :to="{ name: 'organization.create' }"
            ><span class="shape1"></span><span class="shape2"></span
            ><i class="ti-menu-alt sidemenu-icon"></i
            ><span class="sidemenu-label">سفارشات</span></router-link
          >
        </li>
        <li
          class="nav-item"
          v-if="
            $store.state.role == 'organization' ||
              $store.state.role == 'admin' ||
              $store.state.role == 'branches' ||
              $store.state.role == 'izbank-admin' ||
              $store.state.role == 'finance' ||
              $store.state.role == 'org'
          "
        >
          <a class="nav-link with-sub" href="/bonus-cards">
            <span class="shape1"></span><span class="shape2"></span
            ><i class="ti-credit-card sidemenu-icon"></i
            ><span class="sidemenu-label">بن کارت</span
            ><i class="angle fe fe-chevron-left"></i>
          </a>
          <ul class="nav-sub">
            <li
              class="nav-sub-item"
              v-if="
                $store.state.role != 'finance' && $store.state.role != 'org'
              "
            >
              <router-link
                class="nav-sub-link"
                :to="{ name: 'bonusCards.create' }"
                >ثبت سفارش</router-link
              >
            </li>
            <li class="nav-sub-item" v-if="$store.state.role != 'finance'">
              <router-link
                class="nav-sub-link"
                :to="{ name: 'bonusCards.charge' }"
                >شارژ کارت</router-link
              >
            </li>
            <li class="nav-sub-item" v-if="false">
              <router-link
                class="nav-sub-link"
                :to="{ name: 'bonusCards.blockUnblock' }"
                >مسدودی / رفع مسدودی</router-link
              >
            </li>
            <li class="nav-sub-item">
              <router-link
                class="nav-sub-link"
                :to="{ name: 'bonusCards.requests' }"
                >لیست درخواست ها</router-link
              >
            </li>
            <li class="nav-sub-item" v-if="$store.state.role == 'admin'">
              <router-link
                class="nav-sub-link"
                :to="{ name: 'bonusCards.contract' }"
                >ایجاد قرارداد</router-link
              >
            </li>
            <li
              class="nav-sub-item"
              v-if="
                $store.state.role != 'finance' && $store.state.role != 'org'
              "
            >
              <router-link
                class="nav-sub-link"
                :to="{ name: 'organization.personnels' }"
                >پرسنل</router-link
              >
            </li>
          </ul>
        </li>
        <li
          class="nav-item"
          v-if="
            $store.state.role == 'tourismorg' || $store.state.role == 'admin'
          "
        >
          <a class="nav-link with-sub" href="/foreign-bonus-cards">
            <span class="shape1"></span><span class="shape2"></span
            ><i class="ti-credit-card sidemenu-icon"></i
            ><span class="sidemenu-label">بن کارت گردشگری</span
            ><i class="angle fe fe-chevron-left"></i>
          </a>
          <ul class="nav-sub">
            <li class="nav-sub-item">
              <router-link
                class="nav-sub-link"
                :to="{ name: 'foreignBonusCards.create' }"
                >ثبت سفارش</router-link
              >
            </li>
            <li class="nav-sub-item">
              <router-link
                class="nav-sub-link"
                :to="{ name: 'foreignBonusCards.charge' }"
                >شارژ کارت</router-link
              >
            </li>
            <li class="nav-sub-item">
              <router-link
                class="nav-sub-link"
                :to="{ name: 'foreignBonusCards.requests' }"
                >لیست درخواست ها</router-link
              >
            </li>
          </ul>
        </li>
        <li
          class="nav-item"
          v-if="
            $store.state.role == 'branches' ||
              $store.state.role == 'izbank-admin' ||
              $store.state.role == 'admin'
          "
        >
          <a class="nav-link with-sub" href="/bank-branches">
            <span class="shape1"></span><span class="shape2"></span
            ><i class="ti-credit-card sidemenu-icon"></i
            ><span
              class="sidemenu-label"
              v-text="
                $store.state.role == 'admin' || $store.state.role == 'finance'
                  ? 'سفارشات شعب'
                  : 'کارت هدیه'
              "
            ></span
            ><i class="angle fe fe-chevron-left"></i>
          </a>
          <ul class="nav-sub">
            <li class="nav-sub-item">
              <router-link
                class="nav-sub-link"
                :to="{ name: 'bankBranches.create' }"
                >سفارش کارت شخصی سازی شده</router-link
              >
            </li>
            <li class="nav-sub-item">
              <router-link
                class="nav-sub-link"
                :to="{ name: 'bankBranches.charge' }"
                >شارژ کارت هدیه</router-link
              >
            </li>
            <li class="nav-sub-item">
              <router-link
                class="nav-sub-link"
                :to="{ name: 'bankBranches.requests' }"
                >لیست درخواست ها</router-link
              >
            </li>
          </ul>
        </li>

        <li
          class="nav-item"
          v-if="
            $store.state.role == 'admin' || $store.state.role == 'organization'
          "
        >
          <a class="nav-link with-sub" href="/organization-foreigners ">
            <span class="shape1"></span><span class="shape2"></span
            ><i class="icon-people  sidemenu-icon"></i
            ><span
              class="sidemenu-label"
              v-text="
                $store.state.role == 'admin' ||
                $store.state.role == 'organization'
                  ? '  مدیریت اتباع خارجی'
                  : ''
              "
            ></span>
            <i class="angle fe fe-chevron-left"></i>
          </a>
          <ul class="nav-sub">
            <li class="nav-sub-item">
              <router-link
                class="nav-sub-link"
                :to="{ name: 'organizationForeigners.create' }"
              >
                درخواست جدید
              </router-link>
            </li>
            <li class="nav-sub-item">
              <router-link
                class="nav-sub-link"
                :to="{ name: 'organizationForeigners.requests' }"
                >لیست درخواست ها</router-link
              >
            </li>
            <li class="nav-sub-item">
              <router-link
                class="nav-sub-link"
                :to="{ name: 'organizationForeigners.inquiryFidaCode' }"
              >
                استعلام کد فیدا
              </router-link>
            </li>
            <li v-if="$store.state.role == 'admin'" class="nav-sub-item">
              <router-link
                class="nav-sub-link"
                :to="{ name: 'organizationForeigners.consumers.list' }"
                >لیست شرکت های همکار</router-link
              >
            </li>
            <!--           <li class="nav-sub-item" ><router-link class="nav-sub-link"
                :to="{name: 'organizationForeigners.inquiry'}">    استعلام کد فیدا </router-link></li>     -->
          </ul>
        </li>

        <li
          class="nav-item"
          v-if="
            $store.state.role == 'branches' ||
              $store.state.role == 'izbank-admin' ||
              $store.state.role == 'admin' ||
              $store.state.role == 'jahesh' ||
              $store.state.role == 'org'
          "
        >
          <router-link
            class="nav-link"
            :to="{ name: 'bankBranches.blockUnblock' }"
            ><span class="shape1"></span><span class="shape2"></span
            ><i class="ti-credit-card sidemenu-icon"></i
            ><span class="sidemenu-label"
              >مسدودی و رفع مسدودی</span
            ></router-link
          >
        </li>

        <li
          class="nav-item"
          v-if="
            $store.state.role == 'admin' ||
              $store.state.role == 'jahesh' ||
              $store.state.role == 'org'
          "
        >
          <router-link class="nav-link" :to="{ name: 'bonusCards.operations' }"
            ><span class="shape1"></span><span class="shape2"></span
            ><i class="ti-credit-card sidemenu-icon"></i
            ><span class="sidemenu-label">عملیات کارت</span></router-link
          >
        </li>

        <li
          class="nav-item"
          v-if="
            $store.state.role == 'organization' || $store.state.role == 'admin'
          "
        >
          <router-link class="nav-link" :to="{ name: 'bankBranches.cardPin' }"
            ><span class="shape1"></span><span class="shape2"></span
            ><i class="ti-credit-card sidemenu-icon"></i
            ><span class="sidemenu-label"> صدور رمز کارت </span></router-link
          >
        </li>

        <li
          class="nav-item"
          v-if="
            $store.state.role == 'admin' ||
              $store.state.role == 'organization' ||
              $store.state.role == 'jahesh' ||
              $store.state.role == 'branches'
          "
        >
          <router-link
            class="nav-link"
            :to="{ name: 'bonusCards.account.balance' }"
          >
            <span class="shape1"></span><span class="shape2"></span
            ><i class="ti-credit-card sidemenu-icon"></i
            ><span class="sidemenu-label"> دریافت موجودی </span>
          </router-link>
        </li>

        <li
          class="nav-item"
          v-if="$store.state.role == 'admin' || $store.state.role == 'jahesh'"
        >
          <router-link class="nav-link" :to="{ name: 'account.transactions' }">
            <span class="shape1"></span><span class="shape2"></span
            ><i class="ti-list-ol sidemenu-icon"></i
            ><span class="sidemenu-label"> لیست تراکنش ها </span>
          </router-link>
        </li>

        <li
          class="nav-item"
          v-if="$store.state.role == 'admin' || $store.state.role == 'jahesh'"
        >
          <router-link class="nav-link" :to="{ name: 'cards.list' }">
            <span class="shape1"></span><span class="shape2"></span
            ><i class="ti-credit-card sidemenu-icon"></i
            ><span class="sidemenu-label"> لیست کارت های صادر شده </span>
          </router-link>
        </li>

        <!-- <li class="nav-item" 
            v-if="$store.state.role == 'admin'  || $store.state.role == 'jahesh' ">
              <router-link class="nav-link"
                :to="{name: 'account.charge'}">
              <span class="shape1"></span><span
                  class="shape2"></span><i class="ti-list-ol sidemenu-icon"></i><span class="sidemenu-label"> گزارش شارژ 
                  </span>
                </router-link>
          </li> -->

        <li
          class="nav-item"
          v-if="
            $store.state.role == 'admin' ||
              $store.state.role == 'branches' ||
              $store.state.role == 'izbank-admin' ||
              $store.state.role == 'warehouse'
          "
        >
          <router-link
            class="nav-link"
            :to="{ name: 'bankBranches.cardBody.index' }"
            ><span class="shape1"></span><span class="shape2"></span
            ><i class="ti-credit-card sidemenu-icon"></i
            ><span
              class="sidemenu-label"
              v-text="
                $store.state.role == 'warehouse'
                  ? 'مشاهده درخواست شعب'
                  : 'سفارش جسم کارت شعب'
              "
            ></span
          ></router-link>
        </li>
        <li
          class="nav-item"
          v-if="
            $store.state.role == 'warehouse' || $store.state.role == 'admin'
          "
        >
          <router-link
            class="nav-link"
            :to="{ name: 'wareHouse.cardBody.index' }"
            ><span class="shape1"></span><span class="shape2"></span
            ><i class="ti-credit-card sidemenu-icon"></i
            ><span
              class="sidemenu-label"
              v-text="
                $store.state.role == 'warehouse'
                  ? 'ثبت سفارش'
                  : 'سفارش جسم کارت انبار'
              "
            ></span
          ></router-link>
        </li>
        <li
          class="nav-item"
          v-if="
            ($store.state.role == 'branches' ||
              $store.state.role == 'izbank-admin') &&
              false
          "
        >
          <router-link
            class="nav-link"
            :to="{ name: 'bankBranches.transactions' }"
            ><span class="shape1"></span><span class="shape2"></span
            ><i class="ti-credit-card sidemenu-icon"></i
            ><span class="sidemenu-label">تراکنش های کارت</span></router-link
          >
        </li>
        <li
          class="nav-item"
          v-if="
            /*($store.state.userData.isOrganization && $store.state.userData.hasWallet) || (!$store.state.userData.isOrganization && !$store.state.userData.isPishkhan) && */ false
          "
        >
          <router-link class="nav-link" :to="{ name: 'bonusCardDeposit' }"
            ><span class="shape1"></span><span class="shape2"></span
            ><i class="ti-credit-card sidemenu-icon"></i
            ><span class="sidemenu-label">دریافت موجودی کارت</span></router-link
          >
        </li>
        <li class="nav-item" v-if="$store.state.role == 'admin'">
          <router-link class="nav-link" :to="{ name: 'cashback' }"
            ><span class="shape1"></span><span class="shape2"></span
            ><i class="ti-money sidemenu-icon"></i
            ><span class="sidemenu-label">درخواست بازگشت وجه</span></router-link
          >
        </li>
        <li class="nav-item" v-if="$store.state.role == 'admin'">
          <a class="nav-link with-sub" href="/bank-branches">
            <span class="shape1"></span><span class="shape2"></span
            ><i class="ti-credit-card sidemenu-icon"></i
            ><span class="sidemenu-label">کارت نقدی</span
            ><i class="angle fe fe-chevron-left"></i>
          </a>
          <ul class="nav-sub">
            <li class="nav-sub-item">
              <router-link
                class="nav-sub-link"
                :to="{ name: 'debitCards.index' }"
                >لیست</router-link
              >
            </li>
            <li class="nav-sub-item">
              <router-link
                class="nav-sub-link"
                :to="{ name: 'debitCards.report' }"
                >گزارش هزینه ارسال</router-link
              >
            </li>
          </ul>
        </li>
        <li class="nav-item" v-if="$store.state.role == 'logisticsadmin'">
          <router-link class="nav-link" :to="{ name: 'logistic' }">
            <span class="shape1"></span><span class="shape2"></span
            ><i class="ti-credit-card sidemenu-icon"></i
            ><span class="sidemenu-label">مدیریت اسناد</span>
          </router-link>
        </li>
        <li
          class="nav-item"
          v-if="
            $store.state.role == 'admin' ||
              $store.state.role == 'branches' ||
              $store.state.role == 'izbank-admin'
          "
        >
          <router-link class="nav-link" :to="{ name: 'reissue' }"
            ><span class="shape1"></span><span class="shape2"></span
            ><i class="ti-credit-card sidemenu-icon"></i
            ><span class="sidemenu-label">صدور کارت المثنی</span></router-link
          >
        </li>
        <li
          class="nav-item"
          v-if="
            $store.state.role == 'admin' ||
              $store.state.role == 'bankpublicrelations'
          "
        >
          <router-link class="nav-link" :to="{ name: 'orders.medias.index' }"
            ><span class="shape1"></span><span class="shape2"></span
            ><i class="ti-image sidemenu-icon"></i
            ><span class="sidemenu-label">متن ها و تصاویر</span></router-link
          >
        </li>
        <li class="nav-item" v-if="$store.state.role == 'admin'">
          <router-link class="nav-link" :to="{ name: 'calendar' }"
            ><span class="shape1"></span><span class="shape2"></span
            ><i class="ti-calendar sidemenu-icon"></i
            ><span class="sidemenu-label">تقویم مناسبت ها</span></router-link
          >
        </li>
        <li
          class="nav-item"
          v-if="
            $store.state.role != 'branches' && $store.state.userData.isPishkhan
          "
        >
          <router-link class="nav-link" :to="{ name: 'pishkhan.index' }"
            ><span class="shape1"></span><span class="shape2"></span
            ><i class="ti-menu-alt sidemenu-icon"></i
            ><span class="sidemenu-label">سفارشات</span></router-link
          >
        </li>
        <li
          class="nav-item"
          v-if="
            $store.state.role == 'organization' ||
              $store.state.role == 'tourismorg' ||
              $store.state.role == 'branches' ||
              $store.state.role == 'izbank-admin'
          "
        >
          <router-link class="nav-link" :to="{ name: 'organization.dataList' }"
            ><span class="shape1"></span><span class="shape2"></span
            ><i class="ti-image sidemenu-icon"></i
            ><span class="sidemenu-label">متن ها و تصاویر</span></router-link
          >
        </li>
        <li class="nav-item" v-if="$store.state.role == 'admin'">
          <router-link class="nav-link" :to="{ name: 'themes.index' }"
            ><span class="shape1"></span><span class="shape2"></span
            ><i class="ti-image sidemenu-icon"></i
            ><span class="sidemenu-label">طرح کارت ها</span></router-link
          >
        </li>
        <li class="nav-item" v-if="$store.state.role == 'organization'">
          <router-link class="nav-link" :to="{ name: 'organization.calendar' }"
            ><span class="shape1"></span><span class="shape2"></span
            ><i class="ti-calendar sidemenu-icon"></i
            ><span class="sidemenu-label">تقویم مناسبت ها</span></router-link
          >
        </li>

        <li
          class="nav-item has-children"
          v-if="$store.state.role == 'admin' || $store.state.role == 'jahesh'"
        >
          <a class="nav-link with-sub" href="/mosque">
            <span class="shape1"></span><span class="shape2"></span
            ><i class="ti-bar-chart-alt sidemenu-icon"></i
            ><span class="sidemenu-label">سازمان مساجد</span
            ><i class="angle fe fe-chevron-left"></i>
          </a>
          <ul class="nav-sub">
            <li class="nav-sub-item">
              <router-link
                class="nav-sub-link"
                v-if="
                  $store.state.role == 'admin' ||
                    $store.state.role == 'organization' ||
                    $store.state.role == 'jahesh'
                "
                :to="{ name: 'mosque.index' }"
                >لیست</router-link
              >
            </li>
            <li class="nav-sub-item">
              <router-link
                class="nav-sub-link"
                :to="{ name: 'account.withdrawal.report' }"
                >گزارش برداشت از حساب</router-link
              >
            </li>
            <li class="nav-sub-item">
              <router-link
                class="nav-sub-link"
                v-if="
                  $store.state.role == 'admin' ||
                    $store.state.role == 'organization' ||
                    $store.state.role == 'jahesh'
                "
                :to="{ name: 'card.charge.report' }"
                >گزارش شارژ کارت</router-link
              >
            </li>
          </ul>
        </li>

        <li
          class="nav-item"
          v-if="
            $store.state.role == 'organization' || $store.state.role == 'admin'
          "
        >
          <router-link
            class="nav-link"
            :to="{ name: 'organization.uploadData' }"
            ><span class="shape1"></span><span class="shape2"></span
            ><i class="ti-file sidemenu-icon"></i
            ><span class="sidemenu-label">آپلود فایل پن ها</span></router-link
          >
        </li>
        <li
          class="nav-item"
          v-if="
            $store.state.role == 'organization' ||
              ($store.state.role == 'tourismorg' &&
                $store.state.userData.hasWallet)
          "
        >
          <router-link class="nav-link" :to="{ name: 'organization.wallet' }"
            ><span class="shape1"></span><span class="shape2"></span
            ><i class="ti-wallet sidemenu-icon"></i
            ><span class="sidemenu-label">کیف پول</span></router-link
          >
        </li>
        <li
          class="nav-item"
          v-if="
            $store.state.role == 'organization' ||
              ($store.state.role == 'tourismorg' &&
                $store.state.userData.hasWallet)
          "
        >
          <router-link
            class="nav-link"
            :to="{ name: 'organization.transactions' }"
            ><span class="shape1"></span><span class="shape2"></span
            ><i class="ti-bar-chart sidemenu-icon"></i
            ><span class="sidemenu-label">تراکنش ها</span></router-link
          >
        </li>
        <li class="nav-item" v-if="$store.state.role == 'tourismorg'">
          <router-link
            class="nav-link"
            :to="{ name: 'foreignBonusCards.tourists' }"
            ><span class="shape1"></span><span class="shape2"></span
            ><i class="ti-user sidemenu-icon"></i
            ><span class="sidemenu-label">لیست گردشگران</span></router-link
          >
        </li>
        <li
          class="nav-item"
          v-if="
            $store.state.role != 'branches' &&
              $store.state.userData.isOrganization &&
              $store.state.userData.hasWallet &&
              false
          "
        >
          <router-link class="nav-link" :to="{ name: 'bankBranches.customers' }"
            ><span class="shape1"></span><span class="shape2"></span
            ><i class="ti-user sidemenu-icon"></i
            ><span class="sidemenu-label">مشتریان</span></router-link
          >
        </li>
      </ul>
    </div>
  </div></template
>

<script>
export default {
  name: "Sidebar",
};
</script>
